import { render, staticRenderFns } from "./_invoices.vue?vue&type=template&id=2937d423&"
import script from "./_invoices.vue?vue&type=script&lang=ts&"
export * from "./_invoices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2937d423')) {
      api.createRecord('2937d423', component.options)
    } else {
      api.reload('2937d423', component.options)
    }
    module.hot.accept("./_invoices.vue?vue&type=template&id=2937d423&", function () {
      api.rerender('2937d423', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/mypages/_invoices.vue"
export default component.exports